// De begintekst van een schaalvraag ('Nooit', 'Helemaal niet').
//
// Nodig omdat het veld in twee spellingen bestaat: de vragenbouwer schrijft
// `ReachStartLable`, de portfolio-synchronisatie schreef `ReachStartLabel`.
// Lezers die één spelling lazen, toonden bij 44 vragen geen begintekst, en de
// synchronisatie raakte de tekst kwijt bij het kopiëren (#313). Lees hem
// daarom altijd hier.
// AI-CONTEXT: See docs/pitfalls.md#database-firestore-silent-name-mismatch

/**
 * @param {{ ReachStartLable?: string, ReachStartLabel?: string }} [field]
 * @returns {string} De begintekst, of '' als er geen is
 */
const scaleStartLabel = (field) => {
    const fromBuilder = String(field?.ReachStartLable ?? '').trim();
    if (fromBuilder) return field.ReachStartLable;

    const fromSync = String(field?.ReachStartLabel ?? '').trim();
    return fromSync ? field.ReachStartLabel : '';
};

export default scaleStartLabel;
